import { z } from 'zod';

import { isDefined } from '../../../utils.js';
import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export enum FileConversionFormat {
  Base64 = 'Base64',
  Pdf = 'Pdf',
  Base64ToFile = 'Base64ToFile',
}

export const FileConversionBlockConfigSchema = z
  .object({
    fileReference: z.string().optional(),
    base64Payload: z.string().optional(),
    format: z.nativeEnum(FileConversionFormat),
  })
  .refine(
    (config) => {
      const hasFileReference = isDefined(config.fileReference) && config.fileReference.length > 0;
      const hasBase64Payload = isDefined(config.base64Payload) && config.base64Payload.length > 0;

      if (config.format === FileConversionFormat.Base64ToFile) {
        return hasBase64Payload && !hasFileReference;
      }
      return hasFileReference && !hasBase64Payload;
    },
    {
      message:
        'Base64ToFile format requires base64Payload (and no fileReference); other formats require fileReference (and no base64Payload)',
    }
  );

export const FileConversionBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.FileConversion),
  config: FileConversionBlockConfigSchema,
});

export type FileConversionBlock = z.infer<typeof FileConversionBlockSchema>;
